import { MILL_1 } from "@/setup/mill-config/mill-config";
import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { CatalogSectionFamily } from "../models/CatalogSectionFamily";
import { Section } from "../models/Section";

export const getSectionFamilies = async (
	params: {
		sectionFamilyId?: number | null;
		defaultAreaId?: string | number | null;
	},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params.sectionFamilyId)
		parameters.push({ name: "SectionFamilyId", value: params.sectionFamilyId });

	const resp = await apiService.callV2(
		`${Number(params.defaultAreaId) === MILL_1.id ? "[M1].[GetSectionFamilies]" : "[M2].[GetSectionFamilies]"}`,
		parameters,
		signal,
	);

	if (resp.ok) {
		const sectionFamiliesRaw = get(resp, "data.tables[0].rows", []) as Omit<
			CatalogSectionFamily,
			"Sections"
		>[];
		const sections = get(resp, "data.tables[1].rows", []) as Section[];

		const sectionFamilies: CatalogSectionFamily[] = sectionFamiliesRaw.map(
			(family) => {
				const sectionsOfFamily = sections.filter(
					(s) => s.SectionFamilyId === family.SectionFamilyId,
				);

				return {
					...family,
					SectionsArray: sectionsOfFamily,
					SectionsName: sectionsOfFamily.map((s) => s.SectionName).join(", "),
				};
			},
		);

		return sectionFamilies;
	} else {
		throw new Error(resp.message || "Error fetching section families");
	}
};
export const upsertSectionFamily = async (params: {
	sectionFamily: CatalogSectionFamily;
	defaultAreaId?: string | number | null;
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "SectionFamilyId", value: params.sectionFamily.SectionFamilyId },
		{
			name: "SectionFamilyName",
			value: params.sectionFamily.SectionFamilyName,
		},
		{
			name: "SectionFamilyColor",
			value: params.sectionFamily.SectionFamilyColor,
		},
	];

	const resp = await apiService.callV2(
		`${Number(params.defaultAreaId) === MILL_1.id ? "[M1].[UpsertSectionFamily]" : "[M2].[UpsertSectionFamily]"}`,
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error upserting section families");
	}
};

export const deleteSectionFamily = async (params: {
	sectionFamilyId: number | null;
	defaultAreaId?: string | number | null;
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "SectionFamilyId", value: params.sectionFamilyId },
	];

	const resp = await apiService.callV2(
		`${Number(params.defaultAreaId) === MILL_1.id ? "[M1].[DeleteSectionFamily]" : "[M2].[DeleteSectionFamily]"}`,
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting section families");
	}
};
